import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, transferOrdersBatchActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, transferOrdersBatchActions);

export default slice.reducer;
